const About = () => {
  return (
    <div className="my-24 md:px-14 max-w-screen-2xl mx-auto ">About</div>
  )
}

export default About